import { Form } from 'antd';
import cn from 'classnames';
import type React from 'react';
import { type ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '../../typography';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
export type ItemProperties<Values = any> = {
  hideLabel?: boolean;
  marginBottom?: boolean;
  noOptional?: boolean;
} & React.ComponentProps<typeof Form.Item<Values>>;

export const FormItemProvider = ({ children }: { children: ReactNode }): ReactNode => {
  const { t } = useTranslation();

  useEffect(() => {
    document.documentElement.style.setProperty('--optional-label', `"(${t('Optional')})"`);
  }, [t]);

  return children;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
const Item = <Values = any,>({
  className,
  extra,
  hideLabel,
  label,
  marginBottom = true,
  noOptional,
  rules,
  tooltip,
  ...rest
}: ItemProperties<Values>) => {
  const { t } = useTranslation();

  const isRequired = rules?.some((rule) => typeof rule === 'object' && rule.required);

  return (
    <Form.Item<Values>
      className={cn(className, 'ui-form-item', {
        'ui-form-item--hide-label': hideLabel,
        'ui-form-item--horizontal': rest.layout === 'horizontal',
        'ui-form-item--no-margin-bottom': !marginBottom,
        'ui-form-item--no-optional': Boolean(isRequired) || noOptional,
      })}
      extra={
        typeof extra === 'string' ? (
          <Text size="small" type="secondary">
            {t('Info')}: {t(extra)}
          </Text>
        ) : (
          extra
        )
      }
      // TODO: change label color and label font size to fit design
      label={typeof label === 'string' ? t(label) : label}
      rules={rules}
      tooltip={typeof tooltip === 'string' ? t(tooltip) : tooltip}
      {...rest}
    />
  );
};

export default Item;
